import { userConstants } from "../../constant";

const initialState = {
  returns: [],
};

export function sellerReturns(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_SELLER_RETURNS:
      return { ...state, returns: action.returns };

    case userConstants.RESPOND_TO_RETURN: {
      const updated = action.return_request;
      return {
        ...state,
        returns: state.returns.map((r) =>
          r.id === updated.id ? updated : r
        ),
      };
    }

    default:
      return state;
  }
}
